import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    price: null,
    currency: 'USD',
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const premiumInboxSlice = createSlice({
  name: 'premiumInbox',
  initialState,
  reducers: {
    premiumInboxStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        price: blockContent?.price ?? null,
        currency: blockContent?.currency ?? 'USD',
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    premiumInboxClear: () => initialState,

    premiumInboxUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    premiumInboxUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    premiumInboxUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const {
  premiumInboxStore,
  premiumInboxClear,
  premiumInboxUpdateIsLoading,
  premiumInboxUpdateIsActive,
  premiumInboxUpdateBlockContent,
} = premiumInboxSlice.actions;

export const selectPremiumInboxIsLoading = (state) => state.premiumInbox.isLoading;
export const selectPremiumInboxId = (state) => state.premiumInbox.id;
export const selectPremiumInboxUID = (state) => state.premiumInbox.uid;
export const selectPremiumInboxSID = (state) => state.premiumInbox.sid;
export const selectPremiumInboxBlockContent = (state) => state.premiumInbox.blockContent;
export const selectPremiumInboxItemDesign = (state) => state.premiumInbox.itemDesign;
export const selectPremiumInboxContainerDesign = (state) => state.premiumInbox.containerDesign;

export default premiumInboxSlice.reducer;
